import React from 'react';
import { DynamoDBItemWithStaging } from '../types';
import { TASK_STATES } from '../constants';
import EnvelopesSummary from './EnvelopesSummary';

// ─── Types ────────────────────────────────────────────────────────────────────

interface StagingSummaryProps {
    task: DynamoDBItemWithStaging;
    locked?: boolean;
}

// ─── Component ────────────────────────────────────────────────────────────────

const StagingSummary: React.FC<StagingSummaryProps> = ({ task, locked = false }) => {
    return (
        <EnvelopesSummary
            title="Staging Summary"
            envelopes={task.staging_data?.envelopes || []}
            generatedFile={task.staging_data?.generated_file}
            taskState={task.state}
            locked={locked}
            lockedMessage="Complete the Draft stage to unlock staging setup."
            emptyMessage="Staging data will be available once the draft is approved."
            runningState={TASK_STATES.STAGING_RUNNING}
            completedState={TASK_STATES.STAGING_COMPLETED}
        />
    );
};

export default StagingSummary;

